import React from 'react';
import PropTypes from 'prop-types';
import FormErrorHandler from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import ErrorWrapper from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/ErrorWrapper/ErrorWrapper';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import NotificationRecipientInput from './NotificationRecipientInput/NotificationRecipientInput';
import { RaaRoles } from '../../../../utility/SecurityRules';

const ALLOWED_ROLES = [
  RaaRoles.ADMIN.id,
  RaaRoles.MANAGER.id,
  RaaRoles.VIEWER.id,
];

function NotificationGroupFormInner(props) {
  const {
    users,
    notificationGroup,
    errorList,
    onNameChange,
    handleRecipientChange,
    onDeleteBtnPress,
    addRecipientRow,
    isFormDisabled,
  } = props;

  return (
    <FormErrorHandler errorList={errorList} isFormDisabled={isFormDisabled}>
      <div className="mb-4">
        <ErrorWrapper fieldId="name">
          <input
            type="text"
            aria-label="notification group name"
            className="form-control"
            placeholder="Enter Group Name..."
            value={notificationGroup.name}
            onChange={onNameChange}
            disabled={isFormDisabled}
          />
        </ErrorWrapper>
      </div>
      <hr />
      <div className="mb-2">
        <div style={{ maxHeight: '50vh', overflowY: 'auto', paddingRight: '5px' }}>
          {notificationGroup.recipients.map((recipient, index) => (
            <>
              <div key={`recipient-${index}`} className="mb-3 p-2">
                <NotificationRecipientInput
                  recipient={recipient}
                  recipientRowIndex={index}
                  onRecipientChange={handleRecipientChange}
                  onDeleteBtnPress={onDeleteBtnPress}
                  errorList={errorList}
                  users={{
                    ...users,
                    users: users.users.filter(
                      (user) => ALLOWED_ROLES.includes(parseInt(user.roleId, 10)),
                    ),
                  }}
                  disabled={isFormDisabled}
                />
              </div>
              <hr />
            </>
          ))}
        </div>
      </div>

      <div className="text-right">
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={addRecipientRow}
          disabled={isFormDisabled}
        >
          <Icon icon="plus" />
          {' '}
          Add another recipient
        </button>
      </div>
    </FormErrorHandler>
  );
}

NotificationGroupFormInner.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  users: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  notificationGroup: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errorList: PropTypes.array.isRequired,
  onNameChange: PropTypes.func.isRequired,
  handleRecipientChange: PropTypes.func.isRequired,
  onDeleteBtnPress: PropTypes.func.isRequired,
  addRecipientRow: PropTypes.func.isRequired,
  isFormDisabled: PropTypes.bool,
};

NotificationGroupFormInner.defaultProps = {
  users: { users: [] },
  isFormDisabled: false,
};

export default NotificationGroupFormInner;
